import * as React from 'react'
import {ButtonStyled}  from './ButtonStyled'

function Button({ handleClick, children, disabled}) {
   return (  
      <ButtonStyled onClick={handleClick} disabled={disabled}>
         {children}
      </ButtonStyled>
   );
}

export default Button;